import React from "react";
import Header from "../components/Header";
import HeroSlider from "../components/HeroSlider";
import Footer from "../components/Footer";
import PopularFoodItems from "../components/PopularFoodItems";
import PromoBanners from "../components/PromoBanners";
import FoodMenu from "../components/FoodMenu";
import ScrollingTicker from "../components/ScrollingTicker";
import AboutUs from "../components/AboutUs";
import SpecialOffer from "../components/SpecialOffer";
import FullWidthBanner from "../components/FullWidthBanner";
import ExpertChefs from "../components/ExpertChefs";
import LatestNews from "../components/LatestNews";
import InstagramFeed from "../components/InstagramFeed";

const HomePage = () => {
  return (
    <div className="rest-page">
      <Header />
      <HeroSlider />
      <main>
        <PopularFoodItems />
        <PromoBanners />
        <FoodMenu />
        <ScrollingTicker />
        <AboutUs />
        <SpecialOffer />
        <FullWidthBanner />
        <ExpertChefs />
        <LatestNews />
        <InstagramFeed />
      </main>
      <Footer />
    </div>
  );
};

export default HomePage;
